import { useCallback } from 'react';
import { useMixpanel } from './useMixPanel';

export const useAnalytics = () => {
  const mixpanelAnalytics = useMixpanel();

  const appName = localStorage.getItem('analytics_app_name');

  const identifyUser = useCallback(
    (distinctId: string) => {
      mixpanelAnalytics.identify(distinctId);
    },
    [mixpanelAnalytics],
  );

  const incrementUserProperties = useCallback(
    (incrementMap: Record<string, number>) => {
      for (const key in incrementMap) {
        mixpanelAnalytics.increaseUserPropertyValue(key, incrementMap[key]);
      }
    },
    [mixpanelAnalytics],
  );
  const incrementUserProperty = useCallback(
    (key: string, value: number) => {
      mixpanelAnalytics.increaseUserPropertyValue(key, value);
    },
    [mixpanelAnalytics],
  );

  const updateUserProperties = useCallback(
    (properties: Record<string, unknown>) => {
      for (const key in properties) {
        mixpanelAnalytics.updateUserProperty(key, properties[key]);
      }
    },
    [mixpanelAnalytics],
  );
  const updateUserProperty = useCallback(
    (key: string, value: unknown) => {
      mixpanelAnalytics.updateUserProperty(key, value);
    },
    [mixpanelAnalytics],
  );

  const trackAction = useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      const props = properties ?? {};
      props['App'] = appName;
      mixpanelAnalytics.track(event, props);
    },
    [mixpanelAnalytics, appName],
  );

  return {
    identifyUser,
    incrementUserProperties,
    incrementUserProperty,
    updateUserProperties,
    updateUserProperty,
    trackAction,
  };
};
